import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'success';
  size?: 'small' | 'medium' | 'large';
}

export const Button: React.FC<ButtonProps> = ({ children, variant = 'primary', size = 'medium', className = '', ...props }) => {
  const baseStyles = 'font-semibold rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-900 transition-all duration-200 ease-in-out transform hover:scale-105 active:scale-95';

  let variantStyles = '';
  switch (variant) {
    case 'primary':
      variantStyles = 'bg-yellow-400 hover:bg-yellow-300 text-slate-900 focus:ring-yellow-400 shadow-lg shadow-yellow-400/20 hover:shadow-yellow-300/40';
      break;
    case 'secondary':
      variantStyles = 'bg-slate-700 hover:bg-slate-600 text-white focus:ring-slate-500';
      break;
    case 'outline':
      variantStyles = 'bg-transparent border-2 border-slate-300 text-slate-200 hover:bg-slate-700 hover:text-white focus:ring-slate-300';
      break;
    case 'success':
      variantStyles = 'bg-green-500 hover:bg-green-400 text-white focus:ring-green-500 shadow-lg shadow-green-500/20 hover:shadow-green-400/40';
      break;
    default:
      variantStyles = 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500';
      break;
  }

  let sizeStyles = '';
  switch (size) {
    case 'small':
      sizeStyles = 'px-4 py-2 text-sm';
      break;
    case 'large':
      sizeStyles = 'px-8 py-4 text-lg';
      break;
    case 'medium':
    default:
      sizeStyles = 'px-6 py-2.5 text-base';
      break;
  }

  return (
    <button
      className={`${baseStyles} ${variantStyles} ${sizeStyles} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};